export const getFractionalDigits = (n: number): number => n.toString().split(".")[1]?.length ?? 0;

export const floorDecimals = (value: number | string, decimals: number): number =>
  Number(Math.floor(+`${value}e${decimals}`) + "e-" + decimals);

export const roundTo = (n: number, pos: number): number => {
  return Number(n.toFixed(pos));
};
